export let root;
export let currentWindowHeight;
export let currentBreakpoint;

export default function setupIntersect() {
    root = document.documentElement;
    currentWindowHeight = window.innerHeight;
    currentBreakpoint = parseInt(getComputedStyle(root).getPropertyValue('--current-breakpoint'));

    const intersectElements = document.querySelectorAll('[data-intersect]');
    let observer;

    function onChange(changes) {
        changes.forEach(change => {
            if (change.intersectionRatio >= 0.1) {
                change.target.classList.add('intersected');
            }
        });

        const allIntersected = Array.from(intersectElements).every(element => element.classList.contains('intersected'));

        if (allIntersected) {
            observer.disconnect();
        }
    }

    if (intersectElements.length > 0) {
        const config = {
            root: null,
            rootMargin: '-100px',
            threshold: [0.1]
        };

        observer = new IntersectionObserver(onChange, config);

        Array.from(intersectElements).forEach(intersectElement => {
            observer.observe(intersectElement);
        });
    }
}
